/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
// @ts-ignore
import Star from '../../assets/img/0116-star.svg';
import './no-favorites.scss';

const NoFavorites = (props: any) => {
    const { contentName } = props;
    const baseClassName = 'no-favorites';
    return (
        <div className={`${baseClassName}`}>
            <div
                className={`${baseClassName}__header u-els-width-1o2@desktop u-els-width-1o2@wide u-els-width-4o5@tablet u-els-width-4o5@mobile`}
            >
                <div className={`${baseClassName}__header-icon`}>
                    <img
                        id={`${baseClassName}-logo`}
                        src={Star}
                        className={`${baseClassName}__icon`}
                        alt=""
                    />
                </div>
                <div className={`${baseClassName}__message`}>
                    <div className={`${baseClassName}__message-body`}>
                        You do not have any favorited {contentName}s yet.
                        <div
                            className={`${baseClassName}__message-body-subtext`}
                        >
                            To add a {contentName} to your favorites, open up
                            the {contentName} and click on the “Add favorite”
                            button in the upper right section of the screen.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoFavorites;
